export const SearchTypeCheckouts = 13 as const;
export type TSearchTypeCheckouts = typeof SearchTypeCheckouts;

// elementSubType1
export enum CheckoutType {
	ALL = 0,
	USER_ID = 1,
}
